import type { AuthFrame } from '@platform/app-kit';

/** The pre-auth frame copy for the staff console (fixed staff brand). */
export const AUTH_FRAME: AuthFrame = {
  brandName: 'Bigweld admin',
  pitch: 'Every tenant, every cell, one console.',
  supporting: 'Onboard workspaces, keep packages honest and see where each tenant runs.',
};
